"use client";

import { useEffect } from "react";
import MainNavigation from "@/reusable_sections/Header";
import SiteFooter from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
import ServicesOverview from "./sections/ServicesOverview";
import GeneralPestControl from "./sections/GeneralPestControl";
import MosquitoControl from "./sections/MosquitoControl";
import EntryPointTreatments from "./sections/EntryPointTreatments";
import InspectionProcess from "./sections/InspectionProcess";
import QuarterlyPlans from "./sections/QuarterlyPlans";
import WhereWeWork from "./sections/WhereWeWork";
import CommercialBanner from "./sections/CommercialBanner";
import Faq from "./sections/Faq";
import FinalCta from "./sections/FinalCta";
import "./Services.module.css";
function scrollToHashElement() {
  if (typeof window === "undefined") return;
  const rawHash = window.location.hash;
  if (!rawHash) return;
  const id = rawHash.startsWith("#") ? rawHash.slice(1) : rawHash;
  if (!id) return;
  const element = document.getElementById(id);
  if (!element) return;
  const headerOffset = 80;
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
}
export default function ServicesPage() {
  useEffect(() => {
    // Initial mount scroll check with a slight delay for layout stabilization
    const timer = setTimeout(() => {
      scrollToHashElement();
    }, 150);
    const handleHashChange = () => {
      scrollToHashElement();
    };
    window.addEventListener("hashchange", handleHashChange);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);
  return <div className="min-h-screen bg-background text-foreground">
      <MainNavigation />
      <Hero />
      <ServicesOverview />
      <GeneralPestControl />
      <MosquitoControl />
      <EntryPointTreatments />
      <InspectionProcess />
      <QuarterlyPlans />
      <WhereWeWork />
      <CommercialBanner />
      <Faq />
      <FinalCta />
      <SiteFooter />
    </div>;
}